import React from 'react';
import Modal from '../common/Modal';
import Button from '../common/Button';
import { useWallet } from '../../context/WalletContext';
import { useNotify } from '../../context/NotificationContext';
import { hasWallet, WALLETS } from '../../web3/walletConnect';
import { isMobile, buildDeepLink } from '../../web3/mobileDeeplink';

const OPTIONS = [
  { kind: WALLETS.TRUST,       name: 'Trust Wallet',   emoji: '🛡️', tag: 'Recommended' },
  { kind: WALLETS.METAMASK,    name: 'MetaMask',       emoji: '🦊' },
  { kind: WALLETS.BINANCE,     name: 'Binance Wallet', emoji: '🟡' },
  { kind: WALLETS.TOKENPOCKET, name: 'TokenPocket',    emoji: '🅣' },
  { kind: WALLETS.INJECTED,    name: 'Browser Wallet', emoji: '🌐' }
];

export default function WalletModal({ open, onClose }) {
  const { connect, connecting } = useWallet();
  const notify = useNotify();

  async function pick(kind) {
    if (!hasWallet(kind)) {
      if (isMobile()) {
        const link = buildDeepLink(kind);
        if (link) {
          window.location.href = link;
          return;
        }
      }
      notify.error('Wallet not detected', 'Please install or open in a wallet browser.');
      return;
    }
    try {
      await connect(kind);
      notify.success('Wallet connected');
      onClose();
    } catch (e) {
      notify.error('Connection failed', e && (e.message || String(e)));
    }
  }

  return (
    <Modal open={open} onClose={onClose} title="Connect Wallet" subtitle="Choose your wallet to continue">
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {OPTIONS.map(opt => (
          <Button key={opt.kind} variant="ghost" block onClick={() => pick(opt.kind)} loading={connecting} className="btn-lg">
            <span style={{ fontSize: 22, marginRight: 4 }}>{opt.emoji}</span>
            <span style={{ flex: 1, textAlign: 'left', fontWeight: 700 }}>{opt.name}</span>
            {opt.tag && <span className="badge">{opt.tag}</span>}
          </Button>
        ))}
      </div>
      <div className="hint-msg mt-16" style={{ textAlign: 'center' }}>
        On mobile, open this page inside your wallet's DApp browser for best results.
      </div>
    </Modal>
  );
}
